<script context="module" lang="ts">
  export const TAG = {
    label: 'label',
    span: 'span',
    div: 'div',
  } as const

  type Tag = typeof TAG[keyof typeof TAG]
</script>

<script lang="ts">
  import cx from 'classnames'

  let className = ''
  export { className as class }
  export let as: Tag = 'label'
</script>

<svelte:element this={as} class={cx('font-bold', 'text-skin-primary', className)} {...$$restProps}>
  <slot />
</svelte:element>
